import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Button, Input, Modal, ModalBody, ModalFooter } from "@/modules/common/components";
import { forgotPasswordEmailSchema } from "../../schemas";
import useSendFirstAccessCode from "../../hooks/useSendFirstAccessCode";
import { SendFirstAccessCodeDto } from "@/service/dto/admin-auth";

interface EmailStepProps {
  open: boolean;
  onClose: () => void;
  onSent: (email: string) => void;
}

const EmailModalStep = ({ open, onClose, onSent }: EmailStepProps) => {
  const sendFirstAccessCode = useSendFirstAccessCode();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SendFirstAccessCodeDto>({ resolver: zodResolver(forgotPasswordEmailSchema) });

  const onSubmit = async (values: SendFirstAccessCodeDto) => {
    await sendFirstAccessCode.mutateAsync(values);
    onSent(values.email);
    onClose();
  };

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      title="Solicitar novo código"
      description="Informe o e-mail da sua conta para enviarmos um novo código de verificação."
      className="w-11/12"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody className="gap-1">
          <Input label="E-mail" maskType="email" markAsRequired data-test="first-access-password-email" {...register("email")} />
          {errors.email && <p className="mt-1 text-xs text-red-500">{errors.email.message}</p>}
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            className="w-full"
            label="Enviar código"
            disabled={sendFirstAccessCode.isPending}
            loading={sendFirstAccessCode.isPending}
            data-test="first-access-send-code"
          />
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default EmailModalStep;
